import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { BusinessAreaService } from '../business-area.service';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { BusinessAreaModel } from '../business-area.model';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { EditTranslationComponent } from '@fi-app/components/edit-translation/edit-translation.component';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { ExtendSharingService } from '@fi-app/components/extend-sharing/extend-sharing.service';

@Component({
    selector: 'fi-business-area-edit',
    templateUrl: './business-area-edit.component.html',
    styleUrls: ['./business-area-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-area-edit' },
    standalone: false,
})
export class BusinessAreaEditComponent implements OnInit {
    @Input('businessArea') BusinessArea: BusinessAreaModel;
    @ViewChild('editTranslationComponent') editTranslationComponent: EditTranslationComponent;
    EditTabs: EditTabsModel;
    moreMenuItems: MoreMenuMobileSettingsModel;

    constructor(
        private objectTitleService: ObjectTitleService,
        private businessAreaService: BusinessAreaService,
        private appTextService: AppTextService,
        private fiLoadingService: LoadingService,
        private statisticService: StatisticService,
        private saveChangesWarningService: SaveChangesWarningService,
        private fiDialogsService: FiDialogsService,
        private stateService: FiStateService,
        private contentLanguageService: ContentLanguagesService,
        private extendedSharingService: ExtendSharingService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
        this.saveChangesWarningService.start(() => this.BusinessArea);
        this.statisticService.Visit(ModuleType.Core, ObjectTypes.BusinessArea, this.BusinessArea.Id);
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(
            this.objectTitleService.GetTitle(this.BusinessArea.Id, this.BusinessArea.Name, ObjectTypes.BusinessArea),
        );
        this.EditTabs.Tabs.push(
            new EditTabModel(
                this.appTextService.get('common.general'),
                this.appTextService.get('common.general'),
                '/Module/Core/BusinessArea/View/EditGeneric.html',
            ),
        );

        this.moreMenuItems = new MoreMenuMobileSettingsModel();
        this.moreMenuItems.AddListItem(this.appTextService.get('common.select_lang'), () => {
            this.openSelectLanguageDialog();
        });
    }

    private openSelectLanguageDialog() {
        this.contentLanguageService
            .openSelectLanguageDialog(this.editTranslationComponent.ActiveItem)
            .onYesButtonClick((result: number) => (this.editTranslationComponent.ActiveItem = result));
    }

    save() {
        this.fiLoadingService
            .trackPromise(this.businessAreaService.SaveBusinessArea(this.BusinessArea))
            .then((data: number) => {
                if (data) {
                    this.saveChangesWarningService.stop();
                    if (!this.BusinessArea.Id) {
                        this.showSetExtendedSharingSettings(data);
                        return;
                    }
                    this.stateService.go(FiStateNames.BusinessArea.List);
                } else {
                    this.fiDialogsService.error({
                        messageText: this.appTextService.get('error_message.default_header'),
                    });
                }
            });
    }

    private showSetExtendedSharingSettings(businessAreaId: number) {
        this.extendedSharingService
            .getExtendedSharingRecommendationDialog(ObjectTypes.BusinessArea)
            .onNoButtonClick(() => this.stateService.go(FiStateNames.BusinessArea.List))
            .onYesButtonClick(() =>
                this.extendedSharingService.openExtendedSharing(businessAreaId, ObjectTypes.BusinessArea),
            );
    }
}
